export const isCellTarget = (data: string | undefined) => data?.includes('cell')
export const isSegmentTarget = (data: string | undefined) => data?.includes('segment')
